import "./styles.scss";

import ManageAccess from "components/common/ManageAccess/manageAccess";
import { ENTITY_TYPE } from "constants/phase";
import { getEntityType } from "helpers";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate, useOutletContext, useParams } from "react-router-dom";

import amplitude from "../../externals/amplitude";
import WorkspaceManagement from "../../views/WorkspaceManagement";
import BasicInfo from "./partials/BasicInfo";
import Feature from "./partials/Features";
import ManageDownloadLimit from "./partials/ManageDownloadLimit";
import MediaContent from "./partials/MediaContent";
import Operations from "./partials/Operations";
import SecurityComponent from "./partials/Security";
import SideBar from "./partials/SideBar";
import SocialAccounts from "./partials/SocialAccounts";
import Users from "./partials/Users";
import WorkSpaceMembers from "./partials/Users/workSpaceMembers";
import SettingComponent from "./SettingComponent";

const OrganisationProfile = (props) => {
  const {
    fetchMe,
    updateClientSetting,
    getClientSetting,
    getUser,
    fetchUserDetails,
    updateUsers,
    getFeatureList,
    getOrganization,
    updateOrganization,
    getUsersByOrganization,
    getAllCategory,
    assignCategoryToOrganization,
    createUserProfile,
    editUserProfile,
    deleteUserProfile,
    addSocialMediaPlatforms,
    addNewUser,
    updateUser,
    getOrganizationListById,
    getUploadPicture,
    getOrgDetails,
    getOrganizationConfigCategory,
    getWorkspaceConfigCategory,
    getOrganizationUsers,
    updateOrganizationMember,
    updateWorkspaceMember,
    removeWorkspaceMember,
    getWorkspaceUsers,
    removeOrganizationMember,
    getOrganizationDetails,
    getWorkspaceDetails,
    resyncIllustoResource,
    createIllustoAccount,
    getWorkspaces,
    editOrganization,
    editWorkspace,
    validateUserAuthentication,
    getOrganizationWorkspaces,
    getVideoGridState,
    updateVideoData,
    resetUserPassword,
    createSocialProfile,
    deleteSocialProfile,
    updateSocialProfile,
    getSocialProfiles,
  } = props;
  const { entityId, parentClientSetting, clientSetting, user, organizations, workspaces, currentRole, entityType } =
    useOutletContext();

  const { id, active_tab } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [active, setActive] = useState(false);

  const [userData, setUserData] = useState({});
  const [currentItem, setCurrentItem] = useState({});
  const [getCategorys, setCategorys] = useState([]);
  const [contentSports, setContentSports] = useState([]);
  const [orgWsData, setOrgWsData] = useState(null);
  const [entityConfig, setEntityConfig] = useState(null);
  const [allWorkspaces, setAllWorkspaces] = useState([]);

  const validateUserAccess = useCallback(async () => {
    if (id) {
      const { value } = await validateUserAuthentication({
        userId: localStorage.getItem("__uid"),
        entityId: id,
      });
      if (!value?.success) {
        navigate("/dashboard");
      }
    }
  }, [id]);
  useEffect(() => {
    validateUserAccess();
  }, [validateUserAccess]);
  const getOrgWsConfigCategory = async () => {
    if (id.startsWith("org")) {
      const { value } = await getOrganizationConfigCategory({ organizationId: id });
      return value;
    } else if (id.startsWith("ws")) {
      const { value } = await getWorkspaceConfigCategory({ workspaceId: id });
      return value;
    }
  };

  const getAllCategorys = async () => {
    let organizationDetailsObj = {};
    const entityType = getEntityType(id);
    if (entityType === ENTITY_TYPE.WORKSPACES) {
      // if enitity is workspace..getch its parent org details
      const configDetails = await getParentEntityDetails(orgWsData?.organizationId);
      if (configDetails) {
        organizationDetailsObj = configDetails?.organizationConfig;
      }
    } else {
      organizationDetailsObj = entityConfig;
    }

    if (orgWsData) {
      const { value } = await getAllCategory({
        entityId: orgWsData?.organizationId,
      });
      if (value?.success) {
        if (entityType === ENTITY_TYPE.WORKSPACES) {
          // if workspace is selected..only category assigned to parent can be assigned
          const categoryList =
            value?.data && value?.data?.filter((data) => organizationDetailsObj?.categories?.includes(data._id));
          setCategorys(categoryList);
        } else {
          setCategorys(value?.data);
        }

        // selected categories
        const categoryId = value.data && value.data?.filter((data) => entityConfig?.categories?.includes(data._id));

        setContentSports(categoryId?.map(({ name }) => name));
      }
    }
  };

  const fetchData = async () => {
    const { value } = await fetchMe();
    setUserData(value.data);
  };

  const fetchUserRole = async () => {
    const value = await fetchMe();
    if (value.value.status) {
      setUserData(value.value.data);
    }
  };
  const getOrganizationsWorkspaces = async () => {
    const value = await getOrganizationWorkspaces({
      organizationId: id,
      pageSize: 100,
      page: 1,
    });
    setAllWorkspaces(value.value.workspaces);
  };
  useEffect(() => {
    fetchUserRole();
    fetchData();
    getOrganizationsWorkspaces();
    // updateSelectedCategories();
  }, [entityId]);

  //Validation Api for storage

  useEffect(() => {
    amplitude.logEvent("settings_viewed");
  }, []);

  const setOrgWsDetails = () => {
    if (id.startsWith("org")) {
      const matchedOrg = organizations?.find((e) => e?.organizationId === id);
      setOrgWsData(matchedOrg);
    } else if (id.startsWith("ws")) {
      const matchedWs = workspaces?.find((e) => e?.wokrspaceId === id);
      setOrgWsData(matchedWs);
    }
  };

  const getEntityDetails = async () => {
    try {
      const entityType = getEntityType(id);
      if (entityType === ENTITY_TYPE.WORKSPACES) {
        // first fetch workspace details
        const { value } = await getWorkspaceDetails({
          entityId: id,
          getConfig: true,
        });

        if (value?.status) {
          // workspace details fetched
          setOrgWsData(value?.workspace);
          setEntityConfig(value?.workspaceConfig);
        }
        // if workspace, get its parent organization details
      } else {
        const { value } = await getOrganizationDetails({
          entityId: id,
          getConfig: true,
        });
        if (value?.status) {
          // workspace details fetched
          setOrgWsData(value?.organization);
          setEntityConfig(value?.organizationConfig);
        } else {
          console.log("Came in else");
        }
      }
    } catch (error) {
      console.log("Error occured");
    }
  };

  const getParentEntityDetails = async (organizationId) => {
    try {
      if (organizationId) {
        const { value } = await getOrganizationDetails({
          entityId: organizationId,
          getConfig: true,
        });
        if (value?.status) {
          return value;
        } else {
          return null;
        }
      }
    } catch (error) {
      console.log("Error");
    }
  };

  useEffect(() => {
    if (id) {
      setOrgWsDetails();
      getEntityDetails();
    }
  }, [id, workspaces, organizations, pathname]);

  useEffect(() => {
    if (orgWsData) {
      getAllCategorys();
    }
  }, [orgWsData]);
  return (
    <main className="global-main main">
      <div className="page-toolbar">
        <div className="page-breadcrumbs-styled">
          <div className="page-title page-title-op-logo">
            {getEntityType(id) === ENTITY_TYPE.ORGANIZATION ? "Organization" : "Workspace"} profile {">"}
            <div className="organisationprofile--logo">{orgWsData?.displayName || orgWsData?.name}</div>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="op--row">
          {/* Sidebar start */}
          <SideBar
            active_tab={active_tab}
            userData={userData}
            currentItem={currentItem}
            parentClientSetting={parentClientSetting}
            clientSetting={clientSetting}
            setCurrentItem={setCurrentItem}
            active={active}
            setActive={setActive}
            getOrganizationUsers={getOrganizationUsers}
            getWorkspaces={getWorkspaces}
            getWorkspaceUsers={getWorkspaceUsers}
            getClientSetting={getClientSetting}
          />

          <div className="right-block--op">
            {active_tab === "basicinfo" && (
              <BasicInfo
                id={id}
                orgWsData={orgWsData}
                getUploadPicture={getUploadPicture}
                editOrganization={editOrganization}
                editWorkspace={editWorkspace}
                getEntityDetails={getEntityDetails}
              />
            )}
            {active_tab === "features" && (
              <Feature
                getUser={getUser}
                fetchUserDetails={fetchUserDetails}
                updateUsers={updateUsers}
                getFeatureList={getFeatureList}
                getOrganization={getOrganization}
                updateOrganization={updateOrganization}
                getUsersByOrganization={getUsersByOrganization}
                assignCategoryToOrganization={assignCategoryToOrganization}
                createUserProfile={createUserProfile}
                editUserProfile={editUserProfile}
                deleteUserProfile={deleteUserProfile}
                addSocialMediaPlatforms={addSocialMediaPlatforms}
                addNewUser={addNewUser}
                updateUser={updateUser}
                getOrganizationListById={getOrganizationListById}
                getUploadPicture={getUploadPicture}
                getOrgDetails={getOrgDetails}
                getClientSetting={getClientSetting}
                updateClientSetting={updateClientSetting}
                entityConfig={entityConfig}
                getEntityDetails={getEntityDetails}
                createIllustoAccount={createIllustoAccount}
              />
            )}
            {active_tab === "users" && getEntityType(id) === ENTITY_TYPE.ORGANIZATION && (
              <Users
                getOrganizationUsers={getOrganizationUsers}
                getWorkspaceUsers={getWorkspaceUsers}
                organizationId={id}
                updateOrganizationMember={updateOrganizationMember}
                removeOrganizationMember={removeOrganizationMember}
                organizationDetails={orgWsData}
                entityConfig={entityConfig}
              />
            )}
            {active_tab === "users" && getEntityType(id) === ENTITY_TYPE.WORKSPACES && (
              <WorkSpaceMembers
                getWorkspaceUsers={getWorkspaceUsers}
                workspaceId={id}
                updateWorkspaceMember={updateWorkspaceMember}
                removeWorkspaceMember={removeWorkspaceMember}
                getWorkspaceDetails={getWorkspaceDetails}
                workspaceDetails={orgWsData}
                entityConfig={entityConfig}
              />
            )}

            <ManageAccess value={getEntityType(id) === ENTITY_TYPE.ORGANIZATION}>
              {active_tab === "workSpaces" && orgWsData && (
                <WorkspaceManagement profileView={true} workspaceOrganization={orgWsData} />
              )}
            </ManageAccess>
            {active_tab === "socialAccounts" && (
              <SocialAccounts
                id={id}
                createSocialProfile={createSocialProfile}
                deleteSocialProfile={deleteSocialProfile}
                updateSocialProfile={updateSocialProfile}
                getSocialProfiles={getSocialProfiles}
                addSocialMediaPlatforms={addSocialMediaPlatforms}
              />
            )}
            {active_tab === "security" && <SecurityComponent id={id} resetUserPassword={resetUserPassword} />}
            {active_tab === "operations" && (
              <Operations
                id={id}
                // userRole={user?.role}
                allSports={getCategorys}
                getAllSports={getAllCategorys}
                assignCategoryToOrganization={assignCategoryToOrganization}
                contentSports={contentSports}
                setContentSports={setContentSports}
                entityConfig={entityConfig}
                getEntityDetails={getEntityDetails}
                updateClientSetting={updateClientSetting}
              />
            )}
            {active_tab === "mediaContent" && (
              <MediaContent {...props} entityConfig={entityConfig} resyncIllustoResource={resyncIllustoResource} />
            )}
            <SettingComponent {...props} active_tab={active_tab} active={active} selectedCategories={contentSports} />
            {active_tab === "manageDownloadLimit" &&
              entityConfig?.permissions?.manageDownloadLimit &&
              getEntityType(id) === ENTITY_TYPE.ORGANIZATION && (
                <ManageDownloadLimit
                  {...props}
                  getVideoGridState={getVideoGridState}
                  allWorkspaces={allWorkspaces}
                  entityConfig={entityConfig}
                  getWorkspaceDetails={getWorkspaceDetails}
                  updateClientSetting={updateClientSetting}
                  updateVideoData={updateVideoData}
                />
              )}
          </div>
        </div>
      </div>
    </main>
  );
};
export default OrganisationProfile;
